import { NotFoundComponent } from './404/404.component';
import { ErrorPageComponent } from './error/error.component';

export const PAGE_COMPONENTS = [NotFoundComponent, ErrorPageComponent];

export * from './404/404.component';
export * from './error/error.component';
